import { a as createModalRequestId, i as MODAL_OPEN_REQUEST_EVENT, n as MODAL_OPENED_EVENT, r as MODAL_OPEN_FAILED_EVENT, t as MODAL_GOTO_EVENT } from "./app.shared-B8Jzio6x.js";

var ajax_modal_default = (() => {
    if (!customElements.get("ajax-modal")) customElements.define("ajax-modal", class AjaxModal extends HTMLElement {
        button=this.querySelector("a, button");
        url=this.button?.getAttribute("href") || this.button?.dataset.url || null;
        view=this.dataset.view;
        debugOpen=this.hasAttribute("data-debug-open");
        delay=0;
        getSourceId() {
            const explicitSourceId = this.dataset.sourceId || this.button?.dataset.sourceId;
            if (explicitSourceId) return explicitSourceId;
            if (this.id) return this.id;
            if (this.button?.id) return this.button.id;
            try {
                return `ajax-modal-${new URL(this.url, window.location.origin).pathname.split("/").filter(Boolean).join("-") || "unknown"}-${this.view || "default"}`;
            } catch {
                return `ajax-modal-${this.view || "default"}`;
            }
        }
        getTargetIndex() {
            if (this.hasAttribute("data-index")) return Number.parseInt(this.dataset.index);
            if (this.hasAttribute("data-index-auto")) {
                let activeIndex = null;
                this.closest("slider-component")?.dispatchEvent(new CustomEvent("slider:get-state", {
                    detail: {
                        callback: state => {
                            activeIndex = state.activeIndex;
                        }
                    }
                }));
                return activeIndex;
            }
            return null;
        }
        loadStart() {
            if (!this.button) return;
            this.button.setAttribute("aria-busy", "true");
            this.button.setAttribute("aria-disabled", "true");
        }
        loadEnd() {
            if (!this.button) return;
            this.button.setAttribute("aria-busy", "false");
            this.button.setAttribute("aria-disabled", "false");
        }
        buildRequestUrl() {
            const url = new URL(this.url, window.location.origin);
            if (this.view) url.searchParams.set("view", this.view);
            return url;
        }
        waitForModalResult(requestId) {
            return new Promise((resolve, reject) => {
                const timeout = setTimeout(() => {
                    cleanup();
                    reject(new Error(`[ajax-modal] Timed out waiting for modal request ${requestId}`));
                }, 1e4);
                const onOpened = event => {
                    if (event.detail?.requestId !== requestId) return;
                    cleanup();
                    resolve(event.detail);
                };
                const onFailed = event => {
                    if (event.detail?.requestId !== requestId) return;
                    cleanup();
                    reject(event.detail?.error || new Error("[ajax-modal] Modal open failed"));
                };
                const cleanup = () => {
                    clearTimeout(timeout);
                    window.removeEventListener(MODAL_OPENED_EVENT, onOpened);
                    window.removeEventListener(MODAL_OPEN_FAILED_EVENT, onFailed);
                };
                window.addEventListener(MODAL_OPENED_EVENT, onOpened);
                window.addEventListener(MODAL_OPEN_FAILED_EVENT, onFailed);
            });
        }
        async openModal(targetIndex) {
            this.loadStart();
            const url = this.buildRequestUrl();
            const requestId = createModalRequestId();
            try {
                if (!window.MBF?.modalOrchestratorInitialised) {
                    console.error("[ajax-modal] Cannot open modal: modal-orchestrator-not-initialized", {
                        requestId: requestId,
                        url: url.toString()
                    });
                    return;
                }
                window.dispatchEvent(new CustomEvent(MODAL_OPEN_REQUEST_EVENT, {
                    detail: {
                        requestId: requestId,
                        baseUrl: url.toString(),
                        view: this.view,
                        strategy: this.closest("[data-locker-container]") ? "stack" : "replace",
                        context: "ajax-modal",
                        source: {
                            type: "ajax-modal",
                            id: this.getSourceId(),
                            triggerId: this.button?.id || null,
                            context: this.dataset.context || "ajax-modal"
                        }
                    }
                }));
                const {modalId: modalId} = await this.waitForModalResult(requestId);
                if (targetIndex !== null) {
                    const syncGallery = () => {
                        document.querySelector(`[data-locker-container="${modalId}"]`)?.dispatchEvent(new CustomEvent(MODAL_GOTO_EVENT, {
                            detail: {
                                index: targetIndex
                            }
                        }));
                    };
                    setTimeout(syncGallery, this.delay);
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.loadEnd();
            }
        }
        handleClick=async event => {
            event.preventDefault();
            if (this.button.getAttribute("aria-busy") === "true") return;
            const targetIndex = this.getTargetIndex();
            await this.openModal(targetIndex);
        };
        connectedCallback() {
            if (!this.url) return;
            this.button.addEventListener("click", this.handleClick);
            if (this.debugOpen) this.openModal(this.getTargetIndex());
        }
        disconnectedCallback() {
            this.button?.removeEventListener("click", this.handleClick);
        }
    });
})();